import { useState } from "react";
import { Modal } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import { COMMUNICATION_CHANNELS } from "models";
import "modules/CommunicationTemplates/components/EmailTemplateEditorModal/EmailTemplateEditorModal.scss";
import { EmailTemplateEditorModalForm } from "modules/CommunicationTemplates/components/EmailTemplateEditorModal/EmailTemplateEditorModalForm";
import { useUpdateMediumMutation } from "modules/CommunicationTemplates/hooks";

import type { CommunicationMedium } from "models";

type EmailTemplateEditorModalProps = {
  medium: CommunicationMedium | null;
  onClose: () => void;
};

export type EmailMediumFormValues = Pick<CommunicationMedium, "communication_medium_id" | "message" | "subject" | "car_brand" | "car_model">;

const FormHelper = createFormHelper<EmailMediumFormValues>();

export const EmailTemplateEditorModal = ({ onClose, medium }: EmailTemplateEditorModalProps) => {
  const [hasErrors, setHasErrors] = useState(false);

  const { mutateAsync: updateMedium, isPending: isUpdateMediumPending } = useUpdateMediumMutation();

  if (!medium || medium.channel !== COMMUNICATION_CHANNELS.Email) return;

  const handleClose = () => {
    onClose();
    setHasErrors(false);
  };

  const validateFormData = (fields: EmailMediumFormValues) => {
    const hasErrors = !fields.communication_medium_id || !fields.message;
    setHasErrors(hasErrors);
    return !hasErrors;
  };

  const handleSubmit = async (fields: EmailMediumFormValues) => {
    if (!validateFormData(fields)) return;
    await updateMedium({ ...medium, ...fields });
    handleClose();
  };

  return (
    <Modal open={true} size="large">
      <FormHelper.Form
        onSubmit={handleSubmit}
        defaultValues={{
          communication_medium_id: medium.communication_medium_id,
          message: medium.message,
          subject: medium.subject,
          car_brand: medium.car_brand,
          car_model: medium.car_model
        }}
      >
        <div className="EmailTemplateEditorModal">
          <EmailTemplateEditorModalForm
            hasErrors={hasErrors}
            onClose={handleClose}
            onSubmit={handleSubmit}
            medium={medium}
            isUpdateMediumPending={isUpdateMediumPending}
          />
        </div>
      </FormHelper.Form>
    </Modal>
  );
};
